module.exports = __webpack_public_path__ + "img/shot_img120601.b148cbc2.gif";